/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_contact_bug_title_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Short summary of the bug`)
};

const es_contact_bug_title_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Breve resumen del error`)
};

const de_contact_bug_title_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurze Zusammenfassung des Fehlers`)
};

const nl_contact_bug_title_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korte samenvatting van de bug`)
};

const fr_contact_bug_title_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bref résumé du bug`)
};

const it_contact_bug_title_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Breve riassunto del bug`)
};

const pt_br2_contact_bug_title_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Breve resumo do bug`)
};

const pt_contact_bug_title_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Breve resumo do erro`)
};

const ja_contact_bug_title_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バグの概要`)
};

const zh_contact_bug_title_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bug 的简短描述`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const contact_bug_title_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_bug_title_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("contact_bug_title_hint", locale)
	if (locale === "en") return en_contact_bug_title_hint(inputs)
	if (locale === "es") return es_contact_bug_title_hint(inputs)
	if (locale === "de") return de_contact_bug_title_hint(inputs)
	if (locale === "nl") return nl_contact_bug_title_hint(inputs)
	if (locale === "fr") return fr_contact_bug_title_hint(inputs)
	if (locale === "it") return it_contact_bug_title_hint(inputs)
	if (locale === "pt-BR") return pt_br2_contact_bug_title_hint(inputs)
	if (locale === "pt") return pt_contact_bug_title_hint(inputs)
	if (locale === "ja") return ja_contact_bug_title_hint(inputs)
	return zh_contact_bug_title_hint(inputs)
};